import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { h2 } from '@helpers/typography';
import { CustomStyles } from '@stories/Components/Buttons/Button/Button.styles';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import PaginationStyles from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --titleColor: ${brand.primary.purple.base};

  background-color: var(--bgColor);
  color: var(--fgColor);
  overflow: hidden;

  [data-type='custom'] {
    ${CustomStyles(brand.global.white, brand.global.white, brand.primary.purple.base, brand.primary.purple.light)}
  }

  ${PaginationStyles.Container} {
    color: ${brand.primary.purple.base};
  }
`;
const Title = styled.h2 `
  ${h2}
  color: var(--titleColor);
  max-width: var(--maxTextLength);
`;
const CarouselWrapper = styled.div `
  --itemPeek: 80px;
  --itemGutter: 30px;
  --visibleItems: 1;

  margin: 0 calc(var(--itemGutter) * -0.5) 30px;

  @media ${from(Device.TabletSmall)} {
    --visibleItems: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --itemGutter: 40px;
    --itemPeek: 0px;
    --visibleItems: 3;
  }
`;
const Track = styled(MotionTrack) ``;
const Item = styled.li `
  display: flex;
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  padding: 0 calc(var(--itemGutter) / 2);
`;
export default {
    Container,
    Title,
    CarouselWrapper,
    Track,
    Item,
};
